import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "search", "pillGroup", "pill", "list", "card", "emptyState",
    "pagination", "pages", "prevBtn", "nextBtn",
  ];
  static values = { pageSize: { type: Number, default: 8 }, mood: { type: String, default: "all" }, page: { type: Number, default: 1 } };

  connect() {
    this.applyFilters();

    // iOS Safari/Chrome restore horizontal scrollLeft on reload/bfcache —
    // force it back to 0 so the first pill isn't hidden behind the edge.
    if (this.hasPillGroupTarget) this.pillGroupTarget.scrollLeft = 0;
  }

  selectPill(event) {
    const mood = event.currentTarget.dataset.mood;
    this.moodValue = mood;
    this.pageValue = 1;

    this.pillTargets.forEach((pill) => {
      pill.classList.toggle("filter-pill--active", pill.dataset.mood === mood);
    });

    this.applyFilters();
  }

  filter() {
    this.pageValue = 1;
    this.applyFilters();
  }

  prevPage() {
    if (this.pageValue <= 1) return;
    this.pageValue -= 1;
    this.applyFilters();
  }

  nextPage() {
    this.pageValue += 1;
    this.applyFilters();
  }

  goToPage(event) {
    this.pageValue = Number(event.currentTarget.dataset.page);
    this.applyFilters();
  }

  applyFilters() {
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : "";
    const mood = this.moodValue;

    const matches = this.cardTargets.filter((card) => {
      const matchesMood = mood === "all" || card.dataset.mood === mood;
      const matchesQuery = !query || card.dataset.name.includes(query);
      return matchesMood && matchesQuery;
    });

    const totalPages = Math.max(1, Math.ceil(matches.length / this.pageSizeValue));
    if (this.pageValue > totalPages) this.pageValue = totalPages;
    if (this.pageValue < 1) this.pageValue = 1;

    const start = (this.pageValue - 1) * this.pageSizeValue;
    const visible = new Set(matches.slice(start, start + this.pageSizeValue));

    this.cardTargets.forEach((card) => {
      card.hidden = !visible.has(card);
    });

    if (this.hasEmptyStateTarget) this.emptyStateTarget.hidden = matches.length > 0;
    if (this.hasListTarget) this.listTarget.hidden = matches.length === 0;

    this.#renderPagination(totalPages);
  }

  #renderPagination(totalPages) {
    if (!this.hasPaginationTarget) return;

    this.paginationTarget.hidden = totalPages <= 1;
    this.pagesTarget.innerHTML = "";

    for (let i = 1; i <= totalPages; i += 1) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = `pagination__page${i === this.pageValue ? " pagination__page--active" : ""}`;
      btn.textContent = String(i);
      btn.dataset.page = String(i);
      btn.dataset.action = "click->bgm-library#goToPage";
      this.pagesTarget.appendChild(btn);
    }

    this.prevBtnTarget.disabled = this.pageValue <= 1;
    this.nextBtnTarget.disabled = this.pageValue >= totalPages;
  }
}
